import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import "./Ajuda.css";
import React from 'react';

const Ajuda = () => {
    const [menuClose, setMenuClose] = React.useState(false);
    
    const toggleMenu = () => {
        setMenuClose(prev => !prev);
    };

    return(
        <div className="app-container">
            <Sidebar close={menuClose} ajudaActive="active"/>

            <main className="main-content">
                <Topbar page="Ajuda / Suporte" onToggleMenu={toggleMenu} />

                <section className="card">
                    <div className="card-title">Como podemos ajudar?</div>

                    <div className="support-text">
                        Se você tiver qualquer dúvida sobre comissões, extrato, saques ou dados bancários,
                        nossa equipe está pronta para te ajudar.
                    </div>
                    <div className="support-text">
                        Para assuntos financeiros (pagamentos, prazos, saques, ajustes etc.), entre em contato pelo e-mail:
                    </div>

                    <div className="support-email">
                    📧 financeiro@smartolfativos.com.br
                    </div>

                    <div className="support-text">
                    Caso prefira um atendimento mais rápido, você pode falar diretamente conosco via WhatsApp.
                    </div>

                    <div className="button-row">
                    <a 
                        className="whatsapp-btn" 
                        href="https://wa.me/5511996513988"
                        target="_blank"
                    >
                        💬 WhatsApp Suporte
                    </a>

                    <a className="primary-btn" href="#">
                        📘 FAQ (em breve)
                    </a>
                    </div>

                </section>
                
            </main>
        </div>
    )
}

export default Ajuda;